// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-requestLogTime {
  width: 15%;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/manage-request/request-history/request-history.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ","sourcesContent":[".mat-column-requestLogTime {\n    width: 15%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
